import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Modal } from '../../modal.model';
import { LineModalTemplateConfig } from './line-modal-template-config.model';
import { GenerateOTPService } from 'src/app/adapters/generateOTP.service';

@Component({
    selector: 'app-line-modal-template',
    templateUrl: './line-modal-template.component.html',
    styleUrls: ['./line-modal-template.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LineModalTemplateComponent extends Modal {

    countdown:string = '02:59';
    constructor(private generateOTPService: GenerateOTPService) {
        super();
        

        
        
    }

    body:any = []

    lineModalTemplate: LineModalTemplateConfig;

    onInjectInputs(inputs: any): void {
        this.lineModalTemplate = inputs as LineModalTemplateConfig;
        if(this.lineModalTemplate && this.lineModalTemplate.body){
            this.body = this.lineModalTemplate.body;
        }

        this.generateOTPService.getCountdown().subscribe(countdown=>{
            this.countdown = ''+countdown;
            this.body = []
            //แก้ไข ตัวนับเวลาถอยหลังของ request Otp  [setCountdown]
            if(this.lineModalTemplate && this.lineModalTemplate.body){
                this.lineModalTemplate.body.map((item,index)=>{
                    this.body[index] = item.replace("[setCountdown]", this.countdown);
                    //console.log(item,this.countdown)
                })
                //console.log('Countdown SendOTP:',countdown)
            }
        });
    }

    onCancel() {
        this.dismiss('cancel');
    }

    onSubmit() {
        this.close('submit');
    }
}
